import { Grid } from '@material-ui/core';
import React from 'react';

function formatHoursToCalendarSidebarString(h) {
    if (h === 0) {
        return '12 am';
    }
    if (h === 12) {
        return '12 pm';
    }
    if (h > 12) {
        return `${h - 12} pm`;
    }
    return `${h} am`;
}

const CalendarSidebarHours = ({ startHour, endHour, cellHeight }) => {
    return (
        <Grid container item xs={1} direction="column">
            <div
                style={{
                    height: `${cellHeight}px`
                }}
                className="right-and-bottom-border"
            />
            {[...Array(endHour - startHour).keys()].map(e => (
                <div
                    // eslint-disable-next-line react/no-array-index-key
                    key={e}
                    className="right-and-bottom-border"
                    style={{ height: `${cellHeight}px` }}
                >
                    {formatHoursToCalendarSidebarString(e + startHour)}
                </div>
            ))}
        </Grid>
    );
};

export default CalendarSidebarHours;
